export default "__VITE_ASSET__d37dbaf6__"